import DateInput                     from "../DateInput";                    
import { useEffect, useState }       from "react";                           
import { usePxoPage }                from "../../contexts/PxoPageContext";  
import { useUser }                   from "../../contexts/UserContext";                          
import dayjs                         from "dayjs";
import { findPermission }            from "../../utils/UserPermissionUtils";
import api                           from "../../services/api";

const PxoDateFilter = () => {

    const { setSelectedDate, setIsFormPxoOpen, selectedHorizonTypeId, setModalDemandOpen, updatePxoTable } = usePxoPage()
    const { userData } = useUser()

    const [__dateList,      __setDateList           ] = useState([])
    const [__periodUnity,   __setPeriodUnity        ] = useState('year')
    const [__defaultValue,  __setDefaultValue       ] = useState(null)
    const [__horizonOfPlan, __setHorizonOfPlan      ] = useState(null)

    const [__canCreateNewPxo,   __setCanCreateNewPxo ] = useState(false)


    const handleDateChange = (date) => {
        
        if (__periodUnity === 'day') {
            setSelectedDate(dayjs(date, 'DD/MM/YY').format('DD/MM/YY'))
        }
    
        if (__periodUnity === 'month') {
            setSelectedDate(dayjs(date, 'MM/YY').format('MM/YY'))
        }
    
        if (__periodUnity === 'year') {
            setSelectedDate(dayjs(date, 'YYYY').format('YYYY'))
        }

    }

    const fetchPxoTableDates = async () => {
          
        if(!selectedHorizonTypeId) return
        
        try{

            const response = await api.get(`/getPxoDateListByHorizonTypeId/${selectedHorizonTypeId}`)
     
            __setDateList(response.data.pxoDateList)
            __setHorizonOfPlan(response.data.pxoHorizon.ownerHorizonOfPlan)
            setSelectedDate(response.data.pxoDateList[0])
                  
        }catch(error){
            console.log(error)
        }
        
    }



    useEffect(() => {
        
        fetchPxoTableDates()


    }, [selectedHorizonTypeId, updatePxoTable])

    return(

        <section className="w-full bg-neutro borda-cinza rounded-[7px] p-4 flex justify-between gap-[10px]">
            
            <DateInput 

                selectedDateType={__horizonOfPlan?.dateInputFilterFormat || 'year'} 
                
                onChange={handleDateChange} 
                datesList={__dateList} 
                defaultValue={__dateList[0] ? dayjs(__dateList[0], __horizonOfPlan?.horizonPlanFormat) : null}
            />
           
           <div className="flex gap-2">

                {findPermission(userData, "Criação e Editar PxO") && (<>

                    <button 
                        className="mr-15px ml-auto btn btn-transparente-amarelo z-10 h-10" 
                        onClick={() => {setModalDemandOpen(true)}}
                    >
                        Obter Descarga    
                    </button>
                
                
                    <button     
                    
                        className='mr-15px ml-auto btn bg-azul-profundo-m hover:bg-azul-profundo-e z-10 h-10'
                        onClick={() => {setIsFormPxoOpen(true)}}
                    >                  
                    Criar Novo PxO    
                </button>

                </>)}

            </div>

		</section>

    )
}

export default PxoDateFilter